import "ol/ol.css";
import "./style.css";
import { Map, View } from "ol";
import { Control, defaults } from "ol/control";
import { fromLonLat } from "ol/proj";

import { AzureLoginControl } from "./controls/AzureLoginControl";

import { configureMonkeyFetch } from "./auth/monkeyFetch";
import { addSDOLayersAndControls } from "./config/SDOLayersAndControls";
import { addLatLongControl } from "./config/LatLongControl";
import { addBoundaryCodesControl } from "./config/BoundaryCodesControl";
import { addDateInputControl } from "./config/DateInputControl";
import { addHeatmapLayersAndControls } from "./config/HeatmapLayersAndControls";
import { addGeocoderControl } from "./config/GeocoderControl";
import { addBasemapLayersAndControls } from "./config/BasemapLayersAndControls";
import { addWKTLayerAndControl } from "./config/WKTLayerAndControl";
import LayerGroup from "ol/layer/Group";
import { addLayersAndControls } from "./config/LayersAndControls";
import { addFeatureInfoControl } from "./config/FeatureInfoControl";
import {
  getViewFromURL,
  registerMap,
  startSync,
} from "./state/URLStateManager";

const urlView = getViewFromURL();
var view = new View({
  center: urlView ? urlView.center : fromLonLat([7.233208, 50.3750669]),
  zoom: urlView ? urlView.zoom : 8,
});

// monkeypatch fetch to use the flatgeobuf library
configureMonkeyFetch();

const azureLoginControl = new AzureLoginControl();

// Left Generic Controls
export const leftControlDiv = document.createElement("div");
leftControlDiv.id = "controls-left";
const leftControl = new Control({
  element: leftControlDiv,
});

const vectorFeaturesControlDiv = document.createElement("div");
vectorFeaturesControlDiv.className = "vector-feature";
const vectorFeaturesControl = new Control({
  element: vectorFeaturesControlDiv,
  target: leftControlDiv,
});
const map = new Map({
  target: "map",
  layers: [],
  view: view,
  controls: defaults({
    zoom: false,
    attribution: false,
    rotate: false,
  }).extend([azureLoginControl, leftControl]),
});
registerMap(map);
const heatmapLayerGroup = new LayerGroup();
addLatLongControl(map, view, leftControlDiv);
addBoundaryCodesControl(map, view, leftControlDiv, azureLoginControl);
const dateInputControl = addDateInputControl(map, leftControlDiv);
azureLoginControl.once("propertychange", function () {
  addBasemapLayersAndControls(map, azureLoginControl);

  const featureInfoControl = addFeatureInfoControl(map);
  map.addLayer(heatmapLayerGroup);
  addHeatmapLayersAndControls(
    map,
    azureLoginControl,
    dateInputControl,
    leftControlDiv,
    heatmapLayerGroup,
    featureInfoControl,
  );
  // SDO
  addSDOLayersAndControls(
    map,
    azureLoginControl,
    dateInputControl,
    leftControlDiv,
  );
  // vector
  map.addControl(vectorFeaturesControl);
  addWKTLayerAndControl(map, leftControlDiv, view, azureLoginControl)[0];
  addGeocoderControl(map);
  addLayersAndControls(
    map,
    azureLoginControl,
    featureInfoControl,
    vectorFeaturesControlDiv,
  );

  // Start URL state sync after all controls are registered
  startSync();
});
